module.exports = __webpack_public_path__ + "img/jiaoyi.a2b33fc8.png";